import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';

import MapsComponent from './MapsComponent';

const FindUs = ({ title, address }) => {
  return (
    <div style={{ margin: '15px 0 15px 0' }}>
      <center>
        <h3 style={{ fontWeight: 'bold', marginBottom: 20 }}>{title}</h3>
      </center>
      <div className="row">
        <div className="col-md-8">
          <MapsComponent isMarkerShown width="100%" height="340px" />
        </div>
        <Media query={{ minWidth: 768 }}>
          {matches =>
            matches ? (
              <div className="col-md-4">
                <div
                  style={{
                    position: 'absolute',
                    margin: 'auto',
                    width: '100%',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                  }}
                >
                  {address.map(line => {
                    return (
                      <li
                        style={{ listStyleType: 'none', margin: 0 }}
                        key={line}
                      >
                        {line}
                      </li>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div
                style={{ marginTop: 50, marginBottom: 30 }}
                className="col-md-4"
              >
                <div
                  style={{
                    position: 'absolute',
                    margin: 'auto',
                    width: '100%',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                  }}
                >
                  {address.map(line => {
                    return (
                      <li
                        style={{ listStyleType: 'none', margin: 0 }}
                        key={line}
                      >
                        {line}
                      </li>
                    );
                  })}
                </div>
              </div>
            )
          }
        </Media>
      </div>
    </div>
  );
};

FindUs.propTypes = {
  title: PropTypes.string.isRequired,
  address: PropTypes.array.isRequired,
};

export default FindUs;



// WEBPACK FOOTER //
// ./src/components/Main/contact/FindUs.js